var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row align-items-center mb-1" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-3 offset-md-3 text-right center" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-primary btn-fill",
              attrs: { type: "submit" },
              on: { click: _vm.createFunny }
            },
            [_vm._v("Create Funny")]
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-responsive text-center" },
        [
          _c(
            "l-table",
            {
              staticClass:
                "table table-light table-light table-bordered table-hover",
              attrs: { columns: _vm.funnies.columns, data: _vm.funnies.data }
            },
            [
              _vm.funnies.data.length
                ? _c(
                    "template",
                    { slot: "table-row" },
                    _vm._l(_vm.funnies.data, function(item, index) {
                      return _c(
                        "tr",
                        {
                          key: index,
                          class: { inactive: item.status === "0" }
                        },
                        [
                          _c("td", [_vm._v(_vm._s(item.funnyName))]),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "a",
                              {
                                attrs: { href: item.funnyUrl, target: "_blank" }
                              },
                              [_vm._v(_vm._s(item.funnyUrl))]
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c("img", {
                              staticClass: "table-thumbnail",
                              attrs: {
                                title: item.funnyUrl,
                                src: item.funnyUrl
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(item.csvCorporationName))]),
                          _vm._v(" "),
                          _c("td", [
                            item.active != "0"
                              ? _c(
                                  "span",
                                  { staticClass: "badge badge-success" },
                                  [_vm._v(" Active ")]
                                )
                              : _c(
                                  "span",
                                  { staticClass: "badge badge-danger" },
                                  [_vm._v(" Inactive ")]
                                )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "div",
                              {
                                staticClass: "btn-group",
                                attrs: { role: "group" }
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip.top-center",
                                        value: _vm.funnies.tooltips.view,
                                        expression: "funnies.tooltips.view",
                                        modifiers: { "top-center": true }
                                      }
                                    ],
                                    staticClass: "btn btn-secondary btn-sm",
                                    on: {
                                      click: function($event) {
                                        return _vm.viewFunny(item)
                                      }
                                    }
                                  },
                                  [_c("i", { staticClass: "fa fa-eye" })]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip.top-center",
                                        value: _vm.funnies.tooltips.edit,
                                        expression: "funnies.tooltips.edit",
                                        modifiers: { "top-center": true }
                                      }
                                    ],
                                    staticClass: "btn btn-info btn-sm",
                                    on: {
                                      click: function($event) {
                                        return _vm.editFunny(item)
                                      }
                                    }
                                  },
                                  [_c("i", { staticClass: "fa fa-edit" })]
                                )
                              ]
                            )
                          ])
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e()
            ],
            2
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6" }, [
      _c("div", { staticClass: "h2" }, [_vm._v("Funnies")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-077f7ef6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-077f7ef6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Funnies/Funnies.vue
// module id = j4x9
// module chunks = 0